var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"worker.edit.label","bread-crumb-data":_vm.breadCrumbData}},[_c('loading',{attrs:{"id":['workingActivity', 'company', 'worker-select']}}),(_vm.worker)?_c('worker-form',{attrs:{"worker":_vm.worker}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }